export class PepCpj {
    model = {
        id: {
            value: null,
            export: false,
            header: 'ID'
        },
        pep: {
            value: null,
            export: false,
            header: '¿Es el representante legal, directivo o algún socio/accionista/fideicomitente/fiduciario/beneficiario/constituyente un pep?',
            required: 'Campo requerido.'
        },
        nombre_pep: {
            value: '',
            export: false,
            header: 'Nombre del PEP',
            required: 'Nombre es requerido.',
            minLength: 'Mínimo 4 caracteres',
            maxLength: 'Máximo 100 caracteres',
            min: 4,
            max: 100
        },
        cargo_pep: {
            value: '',
            export: false,
            header: 'Cargo',
            required: 'Cargo es requerido.',
            minLength: 'Mínimo 4 caracteres',
            maxLength: 'Máximo 100 caracteres',
            min: 4,
            max: 100
        },
        institucion_trabaja_pep: {
            value: '',
            export: false,
            header: 'Institución donde trabaja o trabajó',
            required: 'Institución es requerido.',
            minLength: 'Mínimo 4 caracteres',
            maxLength: 'Máximo 100 caracteres',
            min: 4,
            max: 100
        },
        fecha_nombramiento_pep: {
            value: null,
            export: false,
            header: 'Fecha del nombramiento de la designación (día/mes/año):',
            required: 'Fecha es requerido'
        },
        fecha_dejo_pep: {
            value: null,
            export: false,
            header: 'Fecha en que dejó de ser PEP, de no estar en funciones (día/mes/año):',
            required: false
        },
        relacion_pep: {
            value: null,
            export: false,
            header: '¿El representante legal, directivo o algún socio/accionista/fideicomitente/fiduciario/beneficiario/constituyente está relacionado con un pep?',
            required: 'Campo requerido.'
        },
        vinculo_pep: {
            value: '',
            export: false,
            header: 'Relación o vínculo:',
            required: 'Relación es requerido.',
            minLength: 'Mínimo 4 caracteres',
            maxLength: 'Máximo 150 caracteres',
            min: 4,
            max: 150
        },
        nombre_vinculo_pep: {
            value: '',
            export: false,
            header: 'Nombre del PEP',
            required: 'Nombre es requerido.',
            minLength: 'Mínimo 4 caracteres',
            maxLength: 'Máximo 150 caracteres',
            min: 4,
            max: 150
        },
        cargo_vinculo_pep: {
            value: '',
            export: false,
            header: 'Cargo',
            required: 'Cargo es requerido.',
            minLength: 'Mínimo 4 caracteres',
            maxLength: 'Máximo 150 caracteres',
            min: 4,
            max: 150
        },
        institucion_vinculo_pep: {
            value: '',
            export: false,
            header: 'Institución donde trabaja o trabajó',
            required: 'Institución es requerido.',
            minLength: 'Mínimo 4 caracteres',
            maxLength: 'Máximo 150 caracteres',
            min: 4,
            max: 150
        },
        fecha_vinculo_pep: {
            value: null,
            export: false,
            header: 'Fecha del nombramiento de la designación (día/mes/año):',
            required: 'Fecha es requerido'
        },
        fecha_culminacion_vinculo_pep: {
            value: null,
            export: false,
            header: 'Fecha en que dejó de ser PEP, de no estar en funciones (día/mes/año):',
            required: false
        },
    }
    optionLabel = 'nombre';
    strPep = <><b>PEP</b>: Son todas aquellas personas naturales, nacionales o extranjeras, que desempeñan o han desempeñado funciones o cargos públicas destacados en el Ecuador o en el Extranjero; 
        o funciones prominentes en una organización internacional, conforme a los lineamentos establecidos por la Unidad de Análisis Financiero y Económico (UAFE), y el organismo de control 
        respectivo.<br /> <b>FAMILIARES O RELACIONADOS:</b> Son las relaciones comerciales o contractuales que involucren al cónyuge o a las personas unidas bajo el régimen legal de unión de hecho reconocida 
        legalmente; o a familiares comprendidos hasta el segundo grado de consanguinidad o primero de afinidad; y, el o los colaborador (es) directo (s) esto es la (s) persona (s) natural (es) 
        con las cuales una Persona Expuesta Políticamente (PEP). se encuentre asociada o vinculada societariamente, o mantenga otro tipo de relaciones empresariales, comerciales o laborales 
        estrechas, serán consideradas como PEP.</>;
}